
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DeptDialog from '@/components/DeptDialog/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';
import DialogCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import DialogEngineer from './DialogSelectEngineer.vue';
import Device from '@/components/DeviceSelectDialog/index.vue'

const orderStatusOptions = [{
  value: '1',
  label: '待处理'
}, {
  value: '2',
  label: '进行中'
}, {
  value: '6',
  label: '未完成'
}, {
  value: '3',
  label: '完结单'
}, {
  value: '8',
  label: '已关闭'
}];
const orderTypeOptions = [{
  value: '2',
  label: '维保'
}, {
  value: '3',
  label: '安装'
}, {
  value: '4',
  label: '巡检'
}];
const orderWarrantyOptions = [{
  value: '1',
  label: '是'
}, {
  value: '2',
  label: '否'
}];
const taskStatusOptions = [{
  value: '2',
  label: '未处理'
}, {
  value: '3',
  label: '进行中'
}, {
  value: '7',
  label: '已上报'
}, {
  value: '4',
  label: '正常已完成'
}, {
  value: '5',
  label: '已关闭'
}];
const costStatusOptions = [{
  value: '1',
  label: '有收费'
}, {
  value: '2',
  label: '无收费'
}];

@Component({
  name: 'SreportFormsSearchItem',
  components: {
    DeptDialog,
    FaultDialog,
    DialogCustomer,
    DialogLveReportDept,
    DialogEngineer,
    Device
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private servicerOptions = [];
  private params: object = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private orderStatusOptions = orderStatusOptions;
  private orderTypeOptions = orderTypeOptions;
  private orderWarrantyOptions = orderWarrantyOptions;
  private taskStatusOptions = taskStatusOptions;
  private costStatusOptions = costStatusOptions;

  created() {
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    } else {
      this.vipLev = 3;
    }
  }

  private servicerdeptReadonly = false;
  private departmentVisible=false;
  @Watch("departmentVisible")
  getDeptVisible(val: boolean) {
    if (val) {
      this.servicerdeptReadonly = true;
    } else {
      this.servicerdeptReadonly = false;
    }
  }
  private selectedDeptServicer() {
    this.deptType = 2;
    this.departmentVisible = true;
  }
  private departmentSelected(val: any) {
    // this.formSearch.deptServicer = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private dialogDeptClose(val: any) {
    this.departmentVisible = val;
  }
  private clearDept() {
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.changeData();
  }

  private customerVisible = false
  private customerReadonly = false;
  @Watch("customerVisible")
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  private selectedCustomer() {
    this.customerVisible = true;
  }
  private closeCustomerHandle(val: any) {
    this.customerVisible = val;
  }
  private customerConfirm(val: any) {
    // this.formSearch.customer = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.customer_company_id;
    this.changeData();
  }
  private clearCustomer() {
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.changeData();
  }

  private vipLev:number=3;
  private deptType:any = 2
  private departmentLevVisible=false;
  @Watch("departmentLevVisible")
  getDepartmentVisible(val: boolean) {
    if (val) {
      this.servicerdeptReadonly = true;
    } else {
      this.servicerdeptReadonly = false;
    }
  }
  private selectedDeptCustomer() {
    if (this.vipLev === 2) {
      this.deptType = 1;
      this.departmentLevVisible = true;
    } else {
      if (!this.searchData.customerCompanyId) {
        this.servicerdeptReadonly = true;
        this.$notify({
          title: '警告',
          message: '请先选择客户',
          type: 'warning'
        });
        return;
      }
      // if (!this.formSearch.customer || !this.formSearch.customer.customer_company_id) {
      //   this.$notify({
      //     title: '警告',
      //     message: '请先选择客户',
      //     type: 'warning'
      //   });
      //   return;
      // }
      this.deptType = 1;
      this.departmentLevVisible = true;
    }
  }
  private selectDeptLev(value:any) {
    // this.formSearch.deptCustomer = value;
    this.searchData.fields = {};
    this.searchData.fields.name = value.name;
    this.searchData.fields.id = value.id;
    this.changeData();
  }
  private handleLveReportDeptConfirm() {
    this.departmentLevVisible = false;
  }
  private closeDialogLveReportDept() {
    this.departmentLevVisible = false;
  }

  // 故障
  private faultVisible = false
  private faultType:any=1
  private faultReadonly = false;
  @Watch("faultVisible")
  getFaultVisible(val: boolean) {
    if (val) {
      this.faultReadonly = true;
    } else {
      this.faultReadonly = false;
    }
  }
  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private faultSelected(val: any) {
    // if (parseInt(this.faultType) === 1) {
    //   this.formSearch.fault = val;
    // } else {
    //   this.formSearch.phenomenon = val;
    // }
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private clearFault() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private selectedEngineervisible = false
  private engineerReadonly = false
  @Watch("selectedEngineervisible")
  getEngineerVisible(val: boolean) {
    if (val) {
      this.engineerReadonly = true;
    } else {
      this.engineerReadonly = false;
    }
  }
  private selectedEngineer() {
    this.selectedEngineervisible = true;
  }
  private closeEngineer(val: any) {
    this.selectedEngineervisible = val;
  }
  private confirmEngineerHandle(val:any) {
    // this.formSearch.engineer = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.user_name;
    this.searchData.fields.id = val.user_id;
    this.changeData();
  }
  private clearEngineer() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private deviceVisible = false
  private deviceReadonly = false
  @Watch("deviceVisible")
  getDeviceVisible(val: boolean) {
    if (val) {
      this.deviceReadonly = true;
    } else {
      this.deviceReadonly = false;
    }
  }
  private selecteDevice() {
    this.deviceVisible = true;
  }
  private confirmDeviceHandle(value: any) {
    // this.formSearch.device = value;
    this.searchData.fields = {};
    this.searchData.fields.name = value.name;
    this.searchData.fields.id = value.id;
    this.changeData();
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }
  private cleardevice() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
